import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Button, ClickAwayListener, Dialog, DialogActions, DialogTitle, Fade, MenuItem, MenuList, Paper, Popper, withStyles } from '@material-ui/core';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import cloneDeep from 'lodash/cloneDeep';
import XLSX from 'xlsx';
import { toast } from 'react-toastify';
import TrashIcon from 'mdi-react/TrashIcon';
import Loader from '../loader/Loader';
import styles from './grid.style';
import GridToolbar from './grid-toolbar';
import GridHead from './grid-head';
import GridBody from './grid-body';
import GridFoot from './grid-foot';
import GridServices from './grid-services';
import DangerButton from '../buttons/DangerButton';

var Grid =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Grid, _React$Component);

  function Grid(props) {
    var _this;

    _classCallCheck(this, Grid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Grid).call(this, props));
    _this.actionButtonWidth = 26;
    _this.cellDefaultWidth = 200;
    _this.cellMinWidth = 150;

    _this.loadColumns = function (props, columns) {
      if (columns) {
        var originalColumns = cloneDeep(props.columns);
        var tempColumns = columns.reduce(function (prev, current, index) {
          current.index = index;
          prev[current.field] = current;
          return prev;
        }, {});
        return originalColumns // Сортируем столбцы, если появились новые столбцы перемещаем их в конец
        .sort(function (a, b) {
          var indexA = tempColumns[a.field] ? tempColumns[a.field].index : 999;
          var indexB = tempColumns[b.field] ? tempColumns[b.field].index : 999;
          return indexA > indexB ? 1 : indexB > indexA ? -1 : 0;
        }) // Выставляем видимость столбца и удаляем не нужное
        .map(function (column) {
          if (tempColumns[column.field]) {
            column.hide = tempColumns[column.field].hide;
            column.width = tempColumns[column.field].width;
          }

          delete column.index;
          return column;
        });
      }

      return props.columns;
    };

    _this.loadFilters = function (props, filters) {
      var originalColumns = cloneDeep(props.columns);
      var newFilters = {};
      originalColumns.forEach(function (column) {
        newFilters[column.field] = {
          field: column.filterField || column.field,
          type: column.type || 'string',
          value: ''
        };

        if (column.filterOperator) {
          newFilters[column.field].operator = column.filterOperator;
        }
      });

      if (filters) {
        for (var field in filters) {
          var filter = filters[field];

          if (filter.value) {
            if (filter.type === 'date' && typeof filter.value === 'string') {
              try {
                newFilters[field].value = parseISO(filter.value);
              } catch (e) {
                console.warn('error parse date from storage');
              }
            } else {
              newFilters[field].value = filter.value;
            }
          }
        }
      }

      return newFilters;
    };
    /**
     * Если таблица невлезает по ширине экрана
     * Синхронизируем положение скрола в шапке и теле таблицы
     * @param event
     */


    _this.listenerHorizontalScroll = function (event) {
      if (_this.bodyContainer) {
        _this.bodyContainer.scrollLeft = event.target.scrollLeft;
      }
    };
    /**
     * Получаем стили ширины таблицы
     */


    _this.getStyleTableWidth = function () {
      var _this$state = _this.state,
          columns = _this$state.columns,
          actions = _this$state.actions;
      var isDropDown = _this.props.isDropDown;
      var width = columns.reduce(function (sum, current) {
        return !current.hide ? sum += current.width || _this.cellDefaultWidth : sum;
      }, 0);
      var actionWidth = actions && actions.length ? actions.length * _this.actionButtonWidth + 32 : 0;
      var dropDownIconWidth = isDropDown ? 34 : 0;
      return {
        minWidth: width + actionWidth + dropDownIconWidth
      };
    };
    /**
     * Получаем стили ширины ячейки
     */


    _this.getStyleCellWidth = function (column) {
      var width = column.width || _this.cellDefaultWidth;

      if (width <= _this.cellMinWidth) {
        width = _this.cellMinWidth;
      }

      return {
        width: width,
        minWidth: width,
        maxWidth: width
      };
    };
    /**
     * Получаем стили ширины столбца "Action buttons"
     */


    _this.getStyleActionCellWidth = function () {
      var actions = _this.state.actions;
      var width = 0;

      if (actions) {
        width = actions.length * _this.actionButtonWidth + 32;
      }

      return {
        width: width,
        minWidth: width,
        maxWidth: width
      };
    };

    _this.onToggleColumnMenu = function (columnMenu) {
      _this.setState({
        columnMenu: columnMenu
      });
    };
    /**
     * Фильтрация данных
     * @param filter
     */


    _this.onChangeFilter = function (filter) {
      if (filter === null) {
        filter = _this.loadFilters(_this.props);
      }

      _this.setState({
        filter: cloneDeep(filter),
        currentPage: 0
      }, function () {
        _this.getData('first');

        _this.clearSelect();

        _this.saveConfig();
      });
    };
    /**
     * Выбор фильтра из сохраненых
     * @param filter
     */


    _this.onChangeFilterFromStorage = function (filter) {
      filter = _this.loadFilters(_this.props, filter);

      _this.setState({
        filter: cloneDeep(filter),
        currentPage: 0
      }, function () {
        _this.getData('first');

        _this.clearSelect();

        _this.saveConfig();
      });
    };
    /**
     * Изменение значения фильтров
     * @param data
     */


    _this.onChangeFilterFromParent = function (data) {
      var filter = _this.state.filter;
      var copyFilter = cloneDeep(filter);

      if (copyFilter[data.field]) {
        copyFilter[data.field].value = data.value;
      }

      _this.setState({
        filter: copyFilter,
        currentPage: 0
      }, function () {
        _this.getData('first');

        _this.clearSelect();

        _this.saveConfig();
      });
    };
    /**
     * Выбор настроек из сохраненых
     * @param settings
     */


    _this.onChangeSettingsFromStorage = function (settings) {
      var columns = _this.loadColumns(_this.props, settings.columns);

      _this.setState({
        columns: columns,
        order: settings.order,
        rowsPerPage: settings.rowsPerPage
      }, function () {
        _this.getData('first');

        _this.clearSelect();

        _this.saveConfig();
      });
    };
    /**
     * Сброс настроек грида на дефолтные
     */


    _this.onResetSettings = function () {
      var _this$props = _this.props,
          columns = _this$props.columns,
          order = _this$props.order;

      _this.setState({
        columns: columns,
        order: order
      }, _this.saveConfig);
    };
    /**
     * Изменение сортировки
     * @param order
     */


    _this.onChangeOrder = function (order) {
      _this.setState({
        order: order
      }, function () {
        _this.getData('first');

        _this.clearSelect();

        _this.saveConfig();
      });
    };
    /**
     * Изменение настроек
     */


    _this.onChangeSetting = function () {
      _this.saveConfig();
    };
    /**
     * Включение/отключение видимости колонок
     * @param columns
     */


    _this.onChangeColumns = function (columns) {
      _this.setState({
        columns: columns
      }, function () {
        _this.getData();

        _this.saveConfig();
      });
    };
    /**
     * Переключение страниц
     * @param currentPage
     * @param rowsPerPage
     * @param direction
     */


    _this.onChangePage = function (currentPage, rowsPerPage, direction) {
      var dataLinks = _this.state.dataLinks;
      /**
       * Для hateoas реализации пейджинации смена страницы (currentPage)
       * или числа строк на страницу (rowsPerPage) должны происходить только
       * после загрузки данных, поскольку пока мы не получили новые links
       * дальше идти мы не можем.
       */

      if (dataLinks) {
        _this.getData(direction, currentPage, rowsPerPage);

        _this.clearSelect();

        _this.saveConfig();
      } else {
        _this.setState({
          currentPage: currentPage,
          rowsPerPage: rowsPerPage
        }, function () {
          _this.getData(direction);

          _this.clearSelect();

          _this.saveConfig();
        });
      }
    };
    /**
     * Открыть контекстоное меню
     * @param event
     */


    _this.openContextMenu = function (event) {
      event.preventDefault();

      _this.setState({
        contextMenu: event.currentTarget
      });
    };
    /**
     * Закрыть контекстное меню
     */


    _this.closeContextMenu = function () {
      _this.setState({
        contextMenu: undefined
      });
    };
    /**
     * Выделение строки
     * @param row
     */


    _this.onSelect = function (row) {
      _this.setState({
        selected: row
      }, function () {
        var onSelect = _this.props.onSelect;

        if (onSelect) {
          onSelect(row);
        }
      });
    };
    /**
     * Обновление грида
     */


    _this.update = function () {
      _this.setState({
        currentPage: 0,
        data: undefined
      }, function () {
        _this.getData();

        _this.clearSelect();
      });
    };
    /**
     * Убрать выделение со строки
     */


    _this.clearSelect = function () {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        _this.setState({
          selected: undefined
        });

        onSelect(undefined);
      }
    };

    _this.onDoubleClick = function (row) {
      var onDoubleClick = _this.props.onDoubleClick;

      if (onDoubleClick) {
        onDoubleClick(row);
      }
    };
    /**
     * Изменение ширины колонок
     * @param field
     * @param width
     */


    _this.onResizeColumnWidth = function (field, width) {
      var columns = _this.state.columns;
      var newColumns = columns.map(function (item) {
        if (item.field === field) {
          item.width = width;
        }

        return item;
      });

      _this.setState({
        columns: newColumns
      });
    };
    /**
     * Изменение позиции колонки
     * @param prevIndex
     * @param nextIndex
     */


    _this.onSortable = function (prevIndex, nextIndex) {
      if (prevIndex === nextIndex) {
        return;
      }

      var columns = _this.state.columns;
      columns.splice(nextIndex, 0, columns.splice(prevIndex, 1)[0]);

      _this.setState({
        columns: columns
      }, _this.saveConfig);
    };

    _this.onChangeListFilters = function (list) {
      _this.setState({
        listFilters: list
      }, _this.saveConfig);
    };

    _this.onChangeListSettings = function (list) {
      _this.setState({
        listSettings: list
      }, _this.saveConfig);
    };

    _this.exportXlsx = function (fileName) {
      var _this$props2 = _this.props,
          url = _this$props2.url,
          externalFilter = _this$props2.externalFilter,
          exportXlsx = _this$props2.exportXlsx,
          transformFilter = _this$props2.transformFilter,
          transformResult = _this$props2.transformResult;
      var _this$state2 = _this.state,
          filter = _this$state2.filter,
          order = _this$state2.order,
          columns = _this$state2.columns;
      var params = {
        limit: 99999,
        filter: filter,
        externalFilter: externalFilter,
        order: order
      };

      _this.setState({
        exportXlsxProgress: true
      });

      function formatData(data) {
        return data.map(function (row) {
          return columns.filter(function (column) {
            return !column.hide;
          }).reduce(function (previous, column) {
            var text = get(row, column.field, '');

            if (column.exportFormatter) {
              previous[column.label] = column.exportFormatter(row);
            } else if (column.formatter) {
              previous[column.label] = column.formatter(row);
            } else if (typeof text === 'string' || typeof text === 'number') {
              previous[column.label] = text;
            } else {
              previous[column.label] = '';
            }

            return previous;
          }, {});
        });
      }

      if (typeof exportXlsx === 'string') {
        _this.setState({
          exportXlsxProgress: false
        }, function () {
          var query = transformFilter(params);
          var url = new URL("".concat(window.location.origin).concat(exportXlsx));

          for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];

            url.searchParams.set(key, isObject(value) ? JSON.stringify(value) : String(value));
          }

          window.open("".concat(url.toString()), '_blank');
        });
      } else {
        if (_this.isOffline()) {
          var data = formatData(_this.state.data || []);

          _this.xls(columns, data, fileName);
        } else {
          GridServices.get(url || '', params, transformResult, transformFilter).subscribe(function (result) {
            _this.setState({
              countItems: result.total,
              loading: false
            });

            var data = formatData(result.data);

            _this.xls(columns, data, fileName);
          }, function (error) {
            _this.setState({
              exportXlsxProgress: false
            });

            console.warn('Ошибка экспорта xlsx', error.message);
          });
        }
      }
    };

    _this.xls = function (columns, data, fileName) {
      var sheetName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Sheet';
      var headers = [];
      var wscols = [];

      if (!fileName) {
        var _this$props3 = _this.props,
            id = _this$props3.id,
            title = _this$props3.title;
        fileName = title || id;
      }

      columns.filter(function (column) {
        return !column.hide;
      }).forEach(function (column) {
        headers.push(column.label);
        wscols.push({
          wpx: (column.width || 200) * 0.77
        }); // 0.77 коэфициент масштабирования, т.к. при экспорте размеры отличаются от оригинальных
      });
      var ws = XLSX.utils.json_to_sheet(data, {
        header: headers,
        skipHeader: false
      });
      var wb = XLSX.utils.book_new();

      if (ws['!ref']) {
        ws['!autofilter'] = {
          ref: ws['!ref']
        };
      }

      ws['!cols'] = wscols;
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, "".concat(fileName, ".xlsx"));

      _this.setState({
        exportXlsxProgress: false
      });
    };

    _this.exportPdf = function () {
      var _this$props4 = _this.props,
          externalFilter = _this$props4.externalFilter,
          exportPdf = _this$props4.exportPdf,
          transformFilter = _this$props4.transformFilter;
      var _this$state3 = _this.state,
          filter = _this$state3.filter,
          order = _this$state3.order;
      var params = {
        limit: 99999,
        filter: filter,
        externalFilter: externalFilter,
        order: order
      };

      _this.setState({
        exportPdfProgress: true
      });

      if (typeof exportPdf === 'string') {
        _this.setState({
          exportPdfProgress: false
        }, function () {
          var query = transformFilter(params);
          var url = new URL("".concat(window.location.origin).concat(exportPdf));

          for (var _i2 = 0, _Object$entries2 = Object.entries(query); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                key = _Object$entries2$_i[0],
                value = _Object$entries2$_i[1];

            url.searchParams.set(key, isObject(value) ? JSON.stringify(value) : String(value));
          }

          window.open("".concat(url.toString()), '_blank');
        });
      } else {
        // @todo тут возможно еще будет нужна реализация экспорта на фронте
        _this.setState({
          exportPdfProgress: false
        });
      }
    };

    _this.openModalDelete = function () {
      _this.setState({
        showModalDelete: true
      });
    };

    _this.closeModalDelete = function () {
      _this.setState({
        showModalDelete: false
      });
    };

    _this.onDelete = function () {
      var onDelete = _this.props.onDelete;
      var loading = _this.state.loading;

      if (loading) {
        return;
      }

      _this.setState({
        loading: true
      });

      if (typeof onDelete === 'string') {
        GridServices.delete(onDelete).subscribe(function () {
          _this.clearSelect();

          _this.callbackDelete();
        }, function (error) {
          _this.callbackDelete();

          toast.error(error.response.message || error.message);
        });
      } else {
        if (onDelete) {
          onDelete(_this.callbackDelete);
        }
      }

      return;
    };

    _this.callbackDelete = function () {
      console.log('callback');

      _this.setState({
        showModalDelete: false,
        loading: false,
        selected: undefined
      }, _this.getData);
    };

    _this.onDropDown = function (row) {
      var _this$props5 = _this.props,
          isDropDown = _this$props5.isDropDown,
          dropDownParams = _this$props5.dropDownParams;

      if (isDropDown) {
        if (!row) {
          _this.setState({
            dropDownData: []
          });
        } else if ('data' in dropDownParams && dropDownParams.data && isArray(dropDownParams.data)) {
          _this.setState({
            dropDownData: dropDownParams.data
          });
        } else if ('url' in dropDownParams && 'paramName' in dropDownParams && dropDownParams.paramName) {
          _this.setState({
            dropDownDataLoading: true
          });

          var params = _defineProperty({}, dropDownParams.paramName, row[dropDownParams.paramName]);

          var transformResult = 'transformResult' in dropDownParams ? dropDownParams.transformResult : undefined;
          var transformFilter = 'transformFilter' in dropDownParams ? dropDownParams.transformFilter : function (params) {
            return params;
          };
          _this.dropDownDataService$ = GridServices.get(dropDownParams.url || '', params, transformResult, transformFilter).subscribe(function (result) {
            _this.setState({
              dropDownData: result.data,
              dropDownDataLoading: false
            });
          }, function () {
            console.warn('Error load data!');

            _this.setState({
              dropDownDataLoading: false
            });
          });
        }
      }
    };
    /**
     * Двойной клик по строке в выпадющем блоке
     * @param row
     */


    _this.onDoubleClickDropDownRow = function (row) {
      var dropDownParams = _this.props.dropDownParams;

      if ('onDoubleClick' in dropDownParams) {
        dropDownParams.onDoubleClick(row);
      }
    };

    var config = _this.getConfig();

    var settings = get(config, "[".concat(props.id, "]"), {});
    _this.state = {
      loading: isUndefined(props.loading) ? true : props.loading,
      columnMenu: {},
      contextMenu: undefined,
      selected: undefined,
      exportXlsxProgress: false,
      exportPdfProgress: false,
      columns: _this.loadColumns(props, settings.columns),
      filter: _this.loadFilters(props, settings.filter),
      listFilters: settings.listFilters && settings.listFilters.length ? settings.listFilters : [],
      listSettings: settings.listSettings && settings.listSettings.length ? settings.listSettings : [],
      order: settings.order || props.order,
      currentPage: 0,
      rowsPerPage: settings.rowsPerPage || 20,
      countItems: 0,
      showModalDelete: false,
      contexts: _toConsumableArray(props.contexts),
      actions: _toConsumableArray(props.actions),
      dropDownData: [],
      dropDownDataLoading: false
    };
    return _this;
  }

  _createClass(Grid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.getData(); // Если передается url удаления то, добавляем кнопку удаления в контенстное меню и в action buttons

      if (this.props.onDelete !== undefined) {
        var _this$state4 = this.state,
            contexts = _this$state4.contexts,
            actions = _this$state4.actions;
        contexts.push({
          label: 'Удалить',
          func: this.openModalDelete
        });
        actions.push({
          label: 'Удалить',
          icon: React.createElement(TrashIcon, {
            size: 18
          }),
          func: this.openModalDelete
        });
        this.setState({
          contexts: contexts,
          actions: actions
        });
      }

      if (this.props.events) {
        this.events = this.props.events.subscribe(function (event) {
          var eventName = '';
          var eventValue = {};

          if (typeof event === 'object') {
            eventName = event.key;
            eventValue = event.value;
          } else {
            eventName = event;
          }

          switch (eventName) {
            case 'update':
              return _this2.update();

            case 'delete':
              return _this2.openModalDelete();

            case 'clearFilter':
              return _this2.onChangeFilter(null);

            case 'changeFilter':
              return _this2.onChangeFilterFromParent(eventValue);

            case 'clearSelect':
              return _this2.clearSelect();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.events) {
        this.events.unsubscribe();
      }

      if (this.service$) {
        this.service$.unsubscribe();
      }

      if (this.dropDownDataService$) {
        this.dropDownDataService$.unsubscribe();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.loading === false && this.props.loading) {
        this.setState({
          loading: true
        });
      }

      if (prevProps.data && this.props.data && !isEqual(prevProps.data, this.props.data)) {
        this.getData();
        this.clearSelect();
      }

      if (prevProps.loading && this.props.loading === false) {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "isOffline",
    value: function isOffline() {
      return this.props.data !== undefined;
    }
    /**
     * Получение настроек из localStorage
     */

  }, {
    key: "getConfig",
    value: function getConfig() {
      var json = localStorage.getItem('grid-view');

      if (json && typeof json === 'string') {
        try {
          return JSON.parse(json);
        } catch (e) {
          console.warn('Fail parse settings');
        }
      }

      return null;
    }
    /**
     * Сохранение настроек в localStorage
     */

  }, {
    key: "saveConfig",
    value: function saveConfig() {
      var id = this.props.id;
      var _this$state5 = this.state,
          columns = _this$state5.columns,
          filter = _this$state5.filter,
          order = _this$state5.order,
          rowsPerPage = _this$state5.rowsPerPage,
          listFilters = _this$state5.listFilters,
          listSettings = _this$state5.listSettings;
      var settings = {
        columns: columns,
        filter: filter,
        order: order,
        rowsPerPage: rowsPerPage,
        listFilters: listFilters,
        listSettings: listSettings
      };
      var config = this.getConfig();

      if (config) {
        config[id] = settings;
      } else {
        config = _defineProperty({}, id, settings);
      }

      localStorage.setItem('grid-view', JSON.stringify(config));
    }
  }, {
    key: "getData",
    value: function getData(linkName, newCurrentPage, newRowsPerPage) {
      var _this3 = this;

      var _this$props6 = this.props,
          data = _this$props6.data,
          url = _this$props6.url,
          externalFilter = _this$props6.externalFilter,
          transformFilter = _this$props6.transformFilter,
          transformResult = _this$props6.transformResult;
      var _this$state6 = this.state,
          currentPage = _this$state6.currentPage,
          rowsPerPage = _this$state6.rowsPerPage,
          order = _this$state6.order,
          columns = _this$state6.columns,
          dataLinks = _this$state6.dataLinks;
      var filter = cloneDeep(this.state.filter); // по скрытым полям фильтровать не нужно

      columns.reduce(function (prev, current) {
        if (current.hide) {
          delete filter[current.field];
        }

        return prev;
      }, {}); // в случае с типом autocomplete используется react-select

      for (var name in filter) {
        var column = filter[name];

        if (column.type === 'autocomplete' || column.type === 'autocompleteMultiple') {
          var value = column.value;

          if (isArray(value)) {
            if (value.length === 0) {
              filter[name].value = undefined;
            } else {
              filter[name].value = value.map(function (item) {
                return item.value;
              });
            }
          } else {
            filter[name].value = value ? value.value : undefined;
          }
        }
      }

      if (data !== undefined) {
        var filteredData = data // фильтрация данных
        .filter(function (row) {
          var _loop = function _loop(filterName) {
            if (filter[filterName] && filter[filterName].value) {
              var _column = columns.find(function (column) {
                return column.field === filterName;
              });

              var filterValue = filter[filterName].value;
              var rowValue = '';

              if (_column && _column.type === 'date' && filterValue) {
                try {
                  filterValue = format(new Date(filter[filterName].value), 'dd.MM.yyyy');
                } catch (e) {
                  console.warn('Error parse Date');
                }
              }

              if (_column && _column.filterFormatter) {
                rowValue = _column.filterFormatter(row).toString().toLowerCase();
              } else if (_column && _column.formatter) {
                rowValue = _column.formatter(row).toString().toLowerCase();
              } else {
                rowValue = get(row, filterName, '').toString().toLowerCase();
              }

              if (filterValue) {
                if (typeof filterValue === 'string') {
                  filterValue = filterValue.toLowerCase();
                }

                if (!rowValue.includes(filterValue)) {
                  return {
                    v: false
                  };
                }
              }
            }
          };

          for (var filterName in filter) {
            var _ret = _loop(filterName);

            if (typeof _ret === "object") return _ret.v;
          }

          return true;
        }); // сортировка данных

        if (order && order.length) {
          filteredData = filteredData.sort(function (a, b) {
            return order.map(function (o) {
              var dir = 1;

              if (o.direction === 'asc') {
                dir = -1;
              }

              var propertyName = o.field;
              a = get(a, propertyName, '');
              b = get(b, propertyName, '');
              if (a) a = a.toString().toLowerCase();
              if (b) b = b.toString().toLowerCase();
              if (a > b) return dir;
              if (a < b) return -dir;
              return 0;
            }).reduce(function firstNonZeroValue(p, n) {
              return p ? p : n;
            }, 0);
          });
        }

        this.setState({
          data: filteredData.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage),
          countItems: filteredData.length
        });
      } else {
        var currentPageValue = newCurrentPage === undefined ? currentPage : newCurrentPage;
        var rowsPerPageValue = newRowsPerPage === undefined ? rowsPerPage : newRowsPerPage;
        var params = {
          limit: rowsPerPageValue,
          offset: currentPageValue * rowsPerPageValue,
          filter: filter,
          externalFilter: externalFilter,
          order: order
        };
        var dataUrl = url;

        if (dataLinks) {
          linkName = linkName || 'current';
          if (dataLinks[linkName]) dataUrl = dataLinks[linkName];
        }

        this.setState({
          loading: true
        });

        if (this.service$) {
          this.service$.unsubscribe();
        }

        this.service$ = GridServices.get(dataUrl || '', params, transformResult, transformFilter).subscribe(function (result) {
          if ('links' in result) {
            if (!result.links.prev) currentPageValue = 0;

            _this3.setState({
              data: result.data,
              countItems: result.data && result.data.length || 0,
              dataLinks: result.links,
              loading: false,
              currentPage: currentPageValue,
              rowsPerPage: rowsPerPageValue
            });
          } else {
            _this3.setState({
              data: result.data,
              countItems: result.total,
              dataLinks: null,
              loading: false
            });
          }
        }, function () {
          console.warn('Error load data!');

          _this3.setState({
            loading: false
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var tableStyle = this.getStyleTableWidth();
      var _this$props7 = this.props,
          classes = _this$props7.classes,
          title = _this$props7.title,
          multipleOrder = _this$props7.multipleOrder,
          filtersMenu = _this$props7.filtersMenu,
          settingsMenu = _this$props7.settingsMenu,
          columnsMenu = _this$props7.columnsMenu,
          buttons = _this$props7.buttons,
          exportXlsx = _this$props7.exportXlsx,
          exportPdf = _this$props7.exportPdf,
          hideFilter = _this$props7.hideFilter,
          onDelete = _this$props7.onDelete,
          isDropDown = _this$props7.isDropDown,
          paginationProps = _this$props7.paginationProps,
          trStyleGenerator = _this$props7.trStyleGenerator,
          orderless = _this$props7.orderless,
          slim = _this$props7.slim;
      var _this$state7 = this.state,
          data = _this$state7.data,
          selected = _this$state7.selected,
          columns = _this$state7.columns,
          actions = _this$state7.actions,
          contexts = _this$state7.contexts,
          loading = _this$state7.loading,
          filter = _this$state7.filter,
          order = _this$state7.order,
          columnMenu = _this$state7.columnMenu,
          countItems = _this$state7.countItems,
          currentPage = _this$state7.currentPage,
          rowsPerPage = _this$state7.rowsPerPage,
          contextMenu = _this$state7.contextMenu,
          listFilters = _this$state7.listFilters,
          listSettings = _this$state7.listSettings,
          exportXlsxProgress = _this$state7.exportXlsxProgress,
          exportPdfProgress = _this$state7.exportPdfProgress,
          showModalDelete = _this$state7.showModalDelete,
          dropDownData = _this$state7.dropDownData,
          dropDownDataLoading = _this$state7.dropDownDataLoading,
          dataLinks = _this$state7.dataLinks;
      return React.createElement("div", {
        className: classes.paper
      }, React.createElement(GridToolbar, {
        classes: classes,
        title: title,
        filter: filter,
        hideFilter: hideFilter,
        filtersMenu: filtersMenu,
        settingsMenu: settingsMenu,
        columnsMenu: columnsMenu,
        buttons: buttons,
        columns: columns,
        selected: selected,
        onChangeFilter: this.onChangeFilter,
        onChangeColumns: this.onChangeColumns,
        listFilters: listFilters,
        onChangeListFilters: this.onChangeListFilters,
        listSettings: listSettings,
        onChangeListSettings: this.onChangeListSettings,
        onChangeFilterFromStorage: this.onChangeFilterFromStorage,
        onChangeSettingsFromStorage: this.onChangeSettingsFromStorage,
        onResetSettings: this.onResetSettings,
        exportXlsx: exportXlsx ? this.exportXlsx : undefined,
        exportXlsxProgress: exportXlsxProgress,
        exportPdf: exportPdf ? this.exportPdf : undefined,
        exportPdfProgress: exportPdfProgress,
        order: order,
        rowsPerPage: rowsPerPage,
        slim: slim
      }), React.createElement("div", {
        className: classes.container
      }, React.createElement("div", {
        className: classes.head,
        ref: function ref(elem) {
          return _this4.bodyContainer = elem;
        }
      }, React.createElement("table", {
        className: classes.table,
        style: tableStyle
      }, React.createElement(GridHead, {
        classes: classes,
        columns: columns,
        actions: actions,
        filter: filter,
        hideFilter: hideFilter,
        order: order,
        orderless: orderless,
        columnMenu: columnMenu,
        multipleOrder: multipleOrder,
        onToggleColumnMenu: this.onToggleColumnMenu,
        onChangeFilter: this.onChangeFilter,
        onChangeOrder: this.onChangeOrder,
        onChangeSetting: this.onChangeSetting,
        getStyleCellWidth: this.getStyleCellWidth,
        getStyleActionCellWidth: this.getStyleActionCellWidth,
        onResizeColumnWidth: this.onResizeColumnWidth,
        onSortable: this.onSortable,
        isDropDown: !!isDropDown,
        slim: slim
      }))), React.createElement("div", {
        className: classes.body,
        onScroll: this.listenerHorizontalScroll
      }, loading && React.createElement("div", {
        className: classes.loading
      }, React.createElement(Loader, null)), React.createElement("table", {
        className: classes.table,
        style: tableStyle
      }, React.createElement(GridBody, {
        classes: classes,
        data: data,
        columns: columns,
        actions: actions,
        selected: selected,
        onSelect: this.onSelect,
        onDoubleClick: this.onDoubleClick,
        openContextMenu: this.openContextMenu,
        getStyleCellWidth: this.getStyleCellWidth,
        getStyleActionCellWidth: this.getStyleActionCellWidth,
        dropDownData: dropDownData,
        onDropDown: this.onDropDown,
        isDropDown: !!isDropDown,
        dropDownDataLoading: dropDownDataLoading,
        onDoubleClickDropDownRow: this.onDoubleClickDropDownRow,
        trStyleGenerator: trStyleGenerator,
        slim: slim
      })))), React.createElement(GridFoot, Object.assign({
        classes: classes,
        countItems: countItems,
        currentPage: currentPage,
        rowsPerPage: rowsPerPage,
        onChangePage: this.onChangePage,
        dataLinks: dataLinks,
        slim: slim
      }, paginationProps)), contexts && React.createElement(Popper, {
        open: Boolean(contextMenu),
        anchorEl: contextMenu,
        transition: true
      }, function (_ref) {
        var TransitionProps = _ref.TransitionProps;
        return React.createElement(Fade, Object.assign({}, TransitionProps, {
          timeout: 350
        }), React.createElement(Paper, null, React.createElement(ClickAwayListener, {
          onClickAway: _this4.closeContextMenu
        }, React.createElement(MenuList, {
          onClick: _this4.closeContextMenu
        }, contexts.map(function (action, index) {
          if (action.visible && !get(selected, action.visible)) {
            return null;
          }

          return React.createElement(MenuItem, {
            key: "context-menu-item-".concat(index),
            onClick: function onClick() {
              return action.func(selected);
            },
            dense: true
          }, action.label);
        })))));
      }), onDelete !== undefined && React.createElement(Dialog, {
        open: showModalDelete,
        onClose: this.closeModalDelete
      }, React.createElement(DialogTitle, null, "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C?"), React.createElement(DialogActions, {
        className: classes.modalActions
      }, React.createElement(Button, {
        onClick: this.closeModalDelete,
        variant: 'contained',
        color: 'primary',
        size: 'small'
      }, "\u041E\u0442\u043C\u0435\u043D\u0430"), React.createElement(DangerButton, {
        onClick: this.onDelete,
        variant: 'contained',
        color: 'primary',
        size: 'small',
        autoFocus: true
      }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))));
    }
  }]);

  return Grid;
}(React.Component);

Grid.defaultProps = {
  multipleOrder: false,
  filtersMenu: true,
  settingsMenu: true,
  columnsMenu: true,
  exportMenu: false,
  exportXlsx: false,
  exportPdf: false,
  hideFilter: false,
  contexts: [],
  actions: [],
  paginationProps: {}
};
export default withStyles(styles, {
  name: 'Grid'
})(Grid);